<div class="comparable-card-container">
  <ng-container *ngIf="changeCardEvent$ | async as event">
    <ng-container
      *ngTemplateOutlet="
        event.source === 'change-btn' || event.source === 'initial'
          ? formTemplate
          : detailsTemplate
      "
    ></ng-container>
  </ng-container>
</div>

<ng-template #formTemplate>
  <div class="form-values-container">
    <sh-dropdown
      items="6"
      condensed
      display="label"
      label="{{ 'syngovia.label.chooseGroup' | translate }}"
      [value]="currentGroupNodeSelectionModel?.groupNode.description"
    >
      <ng-container *ngFor="let key of groupNodeSelectionModelByTypeKeys">
        <ng-container *ngIf="groupNodeSelectionModelByType[key]?.length > 0">
          <sh-menu-item
            *ngFor="let selectionModel of groupNodeSelectionModelByType[key]"
            [label]="selectionModel.groupNode.description"
            (click)="onModalityMenuItemClick(selectionModel)"
            onkeyup="onModalityMenuItemClick(selectionModel)"
            [disabled]="selectionModel.isAllSelected()"
          >
          </sh-menu-item>
          <sh-divider></sh-divider>
        </ng-container>
      </ng-container>
    </sh-dropdown>

    <sh-dropdown
      items="6"
      condensed
      display="label"
      label="{{ 'syngovia.label.chooseDevice' | translate }}"
      [value]="
        currentNodeSelection
          ? nodeDescription(currentNodeSelection.value)
          : undefined
      "
      *ngIf="currentGroupNodeSelectionModel"
    >
      <ng-container
        *ngFor="let nodeSelection of currentGroupNodeSelectionModel.selection"
      >
        <sh-menu-item
          *ngIf="
            !nodeSelection.selected ||
            (nodeSelection.selected &&
              nodeSelection === currentNodeSelection &&
              (changeCardEvent$ | async)?.source === 'change-btn')
          "
          [label]="nodeDescription(nodeSelection.value)"
          (click)="onNodeClicked(nodeSelection)"
          onkeyup="onNodeClicked(nodeSelection)"
        >
        </sh-menu-item>
      </ng-container>
    </sh-dropdown>
  </div>

  <div class="compare-message-container">
    <sh-icon icon="plus" size="l"></sh-icon>
    <sh-text class="message">
      {{ 'syngovia.label.backgroundMessage' | translate }}
    </sh-text>
  </div>
</ng-template>

<ng-template #detailsTemplate>
  <div class="details-card-container">
    <div>
      <div class="change-container">
        <button (click)="onButtonChangeClick()">
          {{ 'syngovia.label.edit' | translate }}
        </button>
        <sh-icon
          icon="delete"
          size="s"
          button
          (click)="onRemoveNodeClick()"
          onkeyup="onRemoveNodeClick()"
        ></sh-icon>
      </div>

      <div class="details-header-container">
        <div
          class="device-image device-image--{{
            currentNodeSelection?.value.type
          }} group-device-image--{{
            currentGroupNodeSelectionModel?.groupNode.type
          }}"
        >
          <img
            [src]="
              dnaSyngoviaIconService.getImgIcon(
                currentNodeSelection?.value.type
              ).src
            "
            [alt]="
              dnaSyngoviaIconService.getImgIcon(
                currentNodeSelection?.value.type
              ).alt
            "
          />
        </div>

        <!-- details -->
        <ng-container
          *ngTemplateOutlet="
            currentNodeSelection?.value.type.startsWith('server')
              ? serverDetails
              : nodeDetails
          "
        ></ng-container>
      </div>
    </div>

    <div class="detailed-infos-container">
      <!-- identification -->
      <ng-container
        *ngTemplateOutlet="
          accordionContent;
          context: { $implicit: { section: 'identification' } }
        "
      ></ng-container>

      <!-- network -->
      <ng-container
        *ngTemplateOutlet="
          accordionContent;
          context: { $implicit: { section: 'network' } }
        "
      ></ng-container>

      <!-- device -->
      <ng-container
        *ngTemplateOutlet="
          accordionContent;
          context: { $implicit: { section: 'device' } }
        "
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #serverDetails>
  <!-- infos container -->
  <div class="infos-container">
    <div>
      <sh-text
        #hostnameTextElement
        class="infos-container__header"
        color="primary"
        matTooltip="{{ currentNodeSelection?.value.hostname ?? NOT_FOUND }}"
        matTooltipClass="syngovia-tooltip"
        matTooltipPosition="above"
        [matTooltipDisabled]="!hasOverflow(hostnameTextElement)"
      >
        {{ currentNodeSelection?.value.hostname ?? NOT_FOUND }}
      </sh-text>

      <sh-text size="body-2" color="secondary">
        {{ 'syngovia.label.serialNumber' | translate }}
        {{ currentNodeSelection?.value.serialNumber ?? NOT_FOUND }}
      </sh-text>
    </div>

    <!-- tags container -->
    <div class="tags-container">
      <sh-text
        *ngIf="currentNodeSelection?.value.msl"
        size="title-1"
        color="primary"
      >
        {{ currentNodeSelection?.value.msl }}
      </sh-text>

      <sh-text
        *ngIf="currentNodeSelection?.value.virtual === 'Yes'"
        size="title-1"
        color="primary"
      >
        {{ 'syngovia.label.virtualized' | translate }}
      </sh-text>
    </div>
  </div>
</ng-template>

<ng-template #nodeDetails>
  <div
    class="infos-container infos-container--{{
      currentGroupNodeSelectionModel?.groupNode.type
    }}"
  >
    <sh-text
      #logicalNameTextElement
      class="infos-container__header"
      color="primary"
      matTooltip="{{
        currentGroupNodeSelectionModel?.groupNode.type === 'client'
          ? (currentNodeSelection?.value.hostname ?? NOT_FOUND)
          : (currentNodeSelection?.value.logicalName ?? NOT_FOUND)
      }}"
      matTooltipClass="syngovia-tooltip"
      matTooltipPosition="above"
      [matTooltipDisabled]="!hasOverflow(logicalNameTextElement)"
    >
      {{
        currentGroupNodeSelectionModel?.groupNode.type === 'client'
          ? (currentNodeSelection?.value.hostname ?? NOT_FOUND)
          : (currentNodeSelection?.value.logicalName ?? NOT_FOUND)
      }}
    </sh-text>

    <!-- tags container -->
    <div class="tags-container">
      <sh-text size="title-1" color="primary">
        {{ currentGroupNodeSelectionModel?.groupNode.description ?? NOT_FOUND }}
      </sh-text>
    </div>
  </div>
</ng-template>

<ng-template #accordionContent let-data>
  <ng-container
    *ngIf="
      ($any(
        sectionColumnsDictionary[currentGroupNodeSelectionModel?.groupNode.type]
      ) ?? sectionColumnsDictionary.default)[data.section] as sectionDetails
    "
  >
    <sh-accordion
      expanded
      label="{{ 'syngovia.label.' + data.section | translate }}"
      class="accordion"
    >
      <ng-container *ngFor="let row of sectionDetails.rows">
        <div class="accordion-row">
          <sh-text size="body-1" color="secondary">
            {{ row.label | translate }}
          </sh-text>
          <sh-text
            #propertyTextElement
            id="selected-node-identification"
            size="body-1"
            color="primary"
            class="accordion-row-value"
            matTooltip=" {{ displayPropertyValue(row.property) }}"
            matTooltipClass="syngovia-tooltip"
            matTooltipPosition="above"
            [matTooltipDisabled]="!hasOverflow(propertyTextElement)"
          >
            {{ displayPropertyValue(row.property) }}
          </sh-text>
        </div>
      </ng-container>
      <ng-container *ngIf="sectionDetails.filler">
        <div
          class="accordion-row"
          *ngFor="let i of [].constructor(sectionDetails.filler)"
        ></div>
      </ng-container>
    </sh-accordion>
  </ng-container>
</ng-template>
